module.exports = __webpack_public_path__ + "img/mobileSvg.733c3871.svg";